import { render, staticRenderFns } from "./NutzergruppenProStore.vue?vue&type=template&id=386b49bd&scoped=true&"
import script from "./NutzergruppenProStore.vue?vue&type=script&lang=js&"
export * from "./NutzergruppenProStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b49bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
